module.exports = __webpack_public_path__ + "img/augmented-reality-app-development.13c1ff97.webp";